// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VBA6","label":"styles_label__1Xtji"};